import RAPIER from '@dimforge/rapier3d-compat';
import type { Vec } from '../destruction/structure';

function rotate(p: Vec, q: { x: number; y: number; z: number; w: number }): Vec {
  const x = 2 * (q.y * p.z - q.z * p.y),
    y = 2 * (q.z * p.x - q.x * p.z),
    z = 2 * (q.x * p.y - q.y * p.x);
  return {
    x: p.x + q.w * x + q.y * z - q.z * y,
    y: p.y + q.w * y + q.z * x - q.x * z,
    z: p.z + q.w * z + q.x * y - q.y * x,
  };
}

/** Rapier 0.20 compounds expose geometric manifold contacts even when their
 * solver-contact list is empty. Convert those subshape-local points using the
 * manifold's actual collider order; do not invent a body-centre impact. */
export function forContactPoints(
  manifold: RAPIER.TempContactManifold,
  a: RAPIER.Collider,
  b: RAPIER.Collider,
  flipped: boolean,
  visit: (point: Vec, distance: number) => void,
): void {
  const solverCount = manifold.numSolverContacts();
  if (solverCount) {
    for (let i = 0; i < solverCount; i++) {
      const p = manifold.solverContactPoint(i);
      if (p) visit(p, manifold.solverContactDist(i));
    }
    return;
  }
  const first = flipped ? b : a,
    shape = first.shape,
    translation = first.translation(),
    rotation = first.rotation();
  const compound = shape instanceof RAPIER.Compound ? shape : undefined,
    index = manifold.subshape1();
  for (let i = 0; i < manifold.numContacts(); i++) {
    let p = manifold.localContactPoint1(i);
    if (!p) continue;
    if (compound) {
      const offset = compound.positions[index],
        q = compound.rotations[index];
      if (!offset || !q) continue;
      p = rotate(p, q);
      p = { x: p.x + offset.x, y: p.y + offset.y, z: p.z + offset.z };
    }
    p = rotate(p, rotation);
    visit(
      { x: p.x + translation.x, y: p.y + translation.y, z: p.z + translation.z },
      manifold.contactDist(i),
    );
  }
}
